import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { usersApi, CreateStaffUserRequest } from '../../api/endpoints/users';

export const useStaffUsers = () => {
  return useQuery({
    queryKey: ['staffUsers'],
    queryFn: () => usersApi.listStaff(),
  });
};

export const useCreateStaffUser = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateStaffUserRequest) => usersApi.createStaff(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['staffUsers'] });
    },
  });
};
